import { getNote, PlayNotesOptions } from '../../../services/bass-service';

import { useEffect, useState } from 'react';
import EarTrainingGame from '../../../components/ear-training/ear-training-game';
import { noteDuration, strings } from '../../../constants/bass';


export default function EarTraining() {
  const [puzzle, setPuzzle] = useState<PlayNotesOptions>();

  function generatePuzzle() {

    const bassString = getRandomIntInclusive(strings.E, strings.G);

    const newPuzzle: PlayNotesOptions = {
      bpm: 100,
      notes: [
        getNote(bassString, getRandomIntInclusive(0, 11), noteDuration.quarter),
        getNote(bassString, getRandomIntInclusive(0, 11), noteDuration.quarter),
        getNote(bassString, getRandomIntInclusive(0, 11), noteDuration.quarter),
        getNote(bassString, getRandomIntInclusive(0, 11), noteDuration.quarter),
        getNote(bassString, getRandomIntInclusive(0, 11), noteDuration.quarter)
      ]
    };

    setPuzzle(newPuzzle);
  }

  function onGameComplete() {
    setPuzzle(undefined);
  }

  function getRandomIntInclusive(min: number, max: number): number {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min); //The maximum is inclusive and the minimum is inclusive
  }

  return (
    <div className="content-with-padding content-max">
      <h2>Ear Training</h2>

      {!puzzle &&
        <div className="card">
          <div className="card-body">
            <p>Listen to a sequence of notes and guess what they are.</p>
            <button className="btn btn-primary" onClick={generatePuzzle}>Generate Puzzle</button>
          </div>
        </div>
      }

      {puzzle && 
        <div className="card">
          <div className="card-body">
            <EarTrainingGame puzzle={puzzle} onComplete={onGameComplete} />
          </div>
        </div>
      }
    </div>
  );
}